export default __webpack_public_path__ + "static/media/local-news-backend.f0bfd5b6.png";